export default {
    message: {
        'header': {
            'online': 'online'
        },
        'footer': {
            'home': 'Home',
            'points': 'Points',
            'vip_zone': 'VIP Zone',
            'order': 'Order',
            'account': 'Account'
        },
        'index': {
            'notice1': "Congratulations to player",
            'notice2': "'s participation, won",
            'notice3': "Let's congratulate him!",
            'hot_spot': 'HOT SPOT',
            'all_goods': 'All goods',
            'promotion_type': 'Promotion Type',
            'partners': 'Partners',
            'announcement': 'The announcement',
            'cancel': 'Cancel',
            'travel_to': 'To travel to',
            'ok': 'submit'
        },
        'goods': {
            'name1': 'Double refund',
            'name2': 'Cash x2 returns',
            'name3': '70 times refund(VIP1)',
            'name4': 'Cash x 72 returns'
        },
        'img': {
            'banner1': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/b1e3c2a662e7333346ef1446db67b4c4.jpeg',
            'banner2': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/c9bf70863920f2a2ac53de21510d71c0.jpeg',
            'banner3': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/069a377136fa1234618c073b166f7ddd.jpeg',
            'banner4': 'https://manage.im2015.com//uploads/attach/2020/03/20200307/4a31597de7b1cc2674314bd8644415f2.jpg',
            'goods_img_10': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',
            'goods_img_50': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',
            'goods_img_5': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',
            'goods_img_150': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',
            'goods_img_25': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',
            'goods_img_500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',
            'goods_img_1500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',
            'goods_img_2500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',
            'goods_img_return': 'https://zhouyaoming.in2015.com//uploads/attach/2021/06/20210615/f5c725953f90a25e5111bd5b14d4952f.png'
        },
        'detail': {
            'please_select': 'Please select',
            'product_description': 'Product description',
            'check_out': 'Check Out',
            'original_price': 'Original price',
            'inventory': 'Inventory',
            'sold': 'Sold',
            'tip_start': 'Promotion success can be upgraded to goods valued at ',
            'tip_end': '₫ free of charge',
            'quantity': 'Quantity',
            'total_price': 'Total price',
            'win_rate': 'Win rate',
            'predict_type': 'Predict type',
            'member_shared': 'Member shared will receive',
            'share_now': 'Share now',
            'copy_the_link': 'Copy the link',
            'send_to_friend': 'Send to friend',
            'copy_success': 'Copy success',
            'copy_error': 'Copy error'
        },
        'integral': {
            'title': 'Points exchange zone',
            'search': 'Search for product information',
            'points': 'Points'
        },
        'vip_zone': {
            'title': 'VIP Goods List',
            'price': 'Price',
            'sales_volume': 'Sales volume'
        },
        'login': {
            'account_login': ['Account login'],
            'login': 'Login',
            'phone': 'Enter your phone number',
            'pwd': 'Fill in your password',
            'no_account': 'Have an existing account?',
            'forgot_password': 'Forgot password',
            'register': 'Register'
        },
        'reset_pwd': {
            'title': 'Retrieve password',
            'get_verification_code': 'Get verification code',
            'confirm': 'Confirm',
            'verification_code': 'verification code',
            'your_new_pwd': 'Your new password',
            'reload': 'Reload',
            'msg_phone': 'Please enter your phone number'
        },
        'register': {
            'register_account': 'Register Account',
            'account': 'Telephone number',
            'pwd': 'Login password',
            'con_pwd': 'Confirm password',
            'register': 'register',
            'tip_account': 'Have an existing account?',
            'by_click': 'By clicking "register" I agree to Interesting mall',
            'privacy_policy': 'Privacy Policy',
            'tip_wrong': '*Wrong mobile phone number will not be able to use the website normally.',
            'msg_phone': 'The phone format error'
        },
        'order': {
            'submit_order': 'Submit order',
            'item': 'Item',
            'payment_method': 'Payment Method',
            'pay_via_balance': 'Pay via balance',
            'balance_available': 'Balance available',
            'total_price': 'Total price',
            'total': 'Total',
            'check_out': 'Check Out',
            'msg_param': 'Parameter is wrong',
            'msg_order_field': 'Failed to load order data',
            'msg_select_payment': 'Please select payment method',
            'tip_create_order': 'Creating order...',
            'payment_succeeded': 'Payment succeeded',
            'payment_fail': 'Payment fail',
            'order_no': 'Order No.',
            'order_time': 'Order time',
            'other': 'Other',
            'total_amount': 'Total Amount',
            'failure_reason': 'failure reason',
            'view_payment_results': 'View payment results',
            'payment_failed_to_repay': 'Payment failed to repay',
            'top_up': 'top-up',
            'hot_spot': 'HOT SPOT',
            'back_home': 'Back home',
            'msg_create_success': 'Order created successfully',
            'confirm_title': 'pay',
            'confirm_msg': 'Payment failed,',
            'confirm_cancel': 'Cancel',
            'confirm_top_up': 'top-up',
            'game_odd': 'Odd',
            'game_even': 'Even',
            'game_title': 'ODD OR EVEN',
            'game_select_title': 'Select your anticipated result',
            'game_odd_number': 'Odd number',
            'game_even_number': 'Even number',
            'game_confirm_selection': 'Confirm selection',
            'game_opening_time': 'Opening time',
            'game_issue': 'Issue',
            'game_number': 'Number',
            'game_results': 'Results',
            'game_submit_err': 'error:order_id is not exist!',
            'game_choose_least': 'Please choose at least one!',
            'game_success': 'success',
            'game_error': 'error',
            'game_confirm': 'Confirm',
            'game_confirm_title': 'message',
            'game_confirm_msg': 'Are you sure select this one?',
            'game_confirm_cancel': 'cancel',
            'chart': 'Chart',
            'close': 'Close',
            'bulls_eye': 'BULLS-EYE',
            'trend_recent': 'Trend of recent 50 periods',
            'number': 'Number',
            'times_without': 'times without',
            'bet': 'bet'
        },
        'my_order': {
            'title': 'My order',
            'operated': 'operated',
            'receive': 'Receive',
            'completed': 'Completed',
            'converted': 'Converted',
            'refund': 'Refund',
            'item_total_amount': 'Item，Total amount',
            'picking_up': 'Picking up',
            'redeem_points': 'Redeem points',
            'processing_pick_up': 'Processing for pick up',
            'hot_spot': 'HOT SPOT',
            'view_details': 'View details',
            'check_tracking': 'Check tracking information',
            'confirm_receival': 'Confirm receival',
            'receipt': 'Receipt',
            'cancel': 'Cancel',
            'confirm_pick_up': 'Confirm pick up',
            'not_sales': 'Is not on sales yet',
            'sales_failed': 'Sales failed',
            'sales_success': 'Sales success',
            'waiting_draw': 'Waiting for draw',
            'bonus_countdown': 'Bonus countdown',
            'redeem_success': 'Redeem success',
            'awarded': 'Awarded',
            'points': 'points',
            'fee': 'Fee',
            'cash': 'cash',
            'sure': 'sure',
            'detail_title': 'Order details',
            'detail_copy': 'Copy',
            'detail_order_no': 'Order No.',
            'detail_order_time': 'Order time',
            'detail_type_order': 'Type of order',
            'detail_status_payment': 'Status of payment',
            'detail_have_pay': 'Have to pay',
            'detail_did_pay': 'Did not pay',
            'detail_promotion_status': 'Promotion status',
            'detail_promotion_period': 'Promotion period',
            'detail_promotion_games': 'Promotion games',
            'detail_opening_time': 'Opening time',
            'detail_my_choice': 'My choice',
            'detail_lottery_numbers': 'lottery Numbers',
            'detail_payment_method': 'Payment Method',
            'detail_total_amount': 'Total Amount',
            'detail_amount_paid': 'Amount paid',
            'detail_re_order': 'Re-order'
        },
        'user': {
            'account': 'Account',
            'available_balance': 'Available balance',
            'my_points': 'My points',
            'active_code': 'Active Code',
            'your_code': 'Enter your code',
            'msg_code': 'Please fill in the exchange code',
            'ok': 'OK',
            'deposit': 'Deposit',
            'withdraw': 'Withdraw',
            'confirm_title': 'Confirm the change?',
            'confirm_msg': 'User avatar change',
            'confirm_cancel': 'Cancel',
            'confirm_ok': 'Confirm',
            'cancelled': 'Cancelled',
            'profile_title': 'User profile',
            'profile_manage_account': 'Manage my account',
            'profile_nickname': 'nickName',
            'profile_real_name': 'realName',
            'profile_email': 'Email',
            'profile_phone': 'Phone',
            'profile_password': 'Password',
            'profile_click_change_password': 'Click change password',
            'profile_save_the_change': 'Save the change',
            'profile_log_out': 'Log out',
            'profile_confirm_title': 'Logout',
            'profile_confirm_msg': 'Confirm logout?',
            'profile_confirm_cancel': 'Cancel',
            'profile_confirm': 'Confirm',
            'change_password_title': 'ChangePassword',
            'change_password_current_pwd': 'Enter your current password',
            'change_password_set_new_pwd': 'Set your new password',
            'change_password_confirm_new_pwd': 'Confirm new password',
            'change_password_confirm_change': 'Confirm change',
            'change_password_msg_current_pwd': 'Please enter you current password',
            'change_password_msg_new_pwd': 'Please enter you new password',
            'change_password_msg_new_pwd_again': 'Please enter you new password again',
            'change_password_msg_not_match': 'Password does not match',
            'user_rank_title': 'Prize opening record',
            'user_menu_bulletin': 'Bulletin',
            'user_menu_vip': 'VIP',
            'user_menu_binance_pay': 'Binance Pay',
            'user_menu_agent': 'Agent',
            'user_menu_balance_details': 'Balance details',
            'user_menu_lottery_record': 'Lottery Record',
            'user_menu_service': 'Service',
            'user_menu_about_us': 'About us'
        },
        'balance_detail': {
            'title': 'Details of balance',
            'total_amount': 'Total amount',
            'top_up': 'Top-up',
            'accumulated_withdrawal': 'Accumulated withdrawal',
            'bill_record': 'Bill record',
            'consumption_records': 'Consumption records',
            'recharge_records': 'Recharge records',
            'points_center': 'Points center',
            'sign_in': 'Sign in to collect points',
            'upgrade_level': 'Upgrade levels to unlock more play！'
        },
        'my_pay': {
            'title': 'Link e-wallet',
            'phone': 'Phone',
            'phone_plac': 'Enter your phone',
            'binance_id': 'Binance ID',
            'binance_id_plac': 'Enter Binance ID',
            'pay_nickname': 'Pay nickname',
            'pay_id': 'Pay ID',
            'pay_id_plac': 'Enter Pay ID',
            'tip': 'Please make sure all information is correct, otherwise you will not be able to withdrawal.',
            'bind': 'Bind',
            'edit': 'Edit',
            'msg_nickname': 'Please enter Pay nickname',
            'confirm_msg': "<b style='color: red'>Note</b>: Pay nickname can only be modified once ! ! !<br>Pay nickname:",
            'confirm_title': 'Binance Pay nickname Edit',
            'confirm_cancel': 'Cancel',
            'confirm_cancelled': 'Cancelled',
            'confirm_confirm': 'Confirm',
            'msg_phone': 'Please enter phone number',
            'msg_binance_id': 'Please enter Binance ID',
            'msg_binance_id_format': 'Binance ID format error',
            'msg_pay_nickname': 'Please enter Pay nickname',
            'msg_pay_id': 'Please enter Pay ID',
            'msg_pay_id_format': 'Pay ID format error',
            'msg_pay_id_length': 'Pay ID length error',
            'msg_binance_pay': 'Binance ID is not Pay ID, Pay ID can be found on the receive page.',
            'msg_confirm_title': 'Binance Pay Confirmation information',
            'msg_confirm_msg1': 'Your Pay nickname',
            'msg_confirm_msg2': 'Your Pay ID',
            'msg_confirm_msg3': 'Note: Once confirmed, it cannot be unbind!',
            'msg_confirm_cancel': 'Cancel',
            'msg_confirm_cancelled': 'Cancelled',
            'msg_confirm': 'Confirm',
            'bind_success_msg': 'Link success，You get'
        },
        'user_bill': {
            'title': 'Details of balance',
            'all': 'All',
            'consumption': 'Consumption',
            'recharge': 'Recharge',
            'income': 'Income'
        },
        'user_integral': {
            'title': 'Details of points',
            'current_points': 'Current points',
            'accumulated_points': 'Accumulated points',
            'accumulated_consumption': 'Accumulated consumption',
            'obtained_today': 'Obtained today',
            'details_points': 'Details of points',
            'increase_points': 'Increase points',
            'points_rewarded_purchasing': 'Points rewarded for purchasing item',
            'earn_points': 'Earn points',
            'points_rewarded_sign': 'Points rewarded for daily sign in',
            'sign_points': 'Points',
            'sign_details': 'Details',
            'sign_signed': 'Signed',
            'sign_sign': 'Sign',
            'sign_accumulated_sign': 'Accumulated sign in',
            'sign_days': 'days',
            'sign_tip2_s': 'It is said that the',
            'sign_tip2_e': ' day of continuos sign in will have huge points rewarded, do not forget to sign in ~~~',
            'sign_click_load_more': 'Click to load more',
            'sign_success': 'Sign in success',
            'sign_awarded': 'Awarded',
            'sign_sure': 'sure',
            'sign_cnum': ["zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine"],
            'sign_msg_signed': 'You have signed in today!',
            'detail_title': 'Order for points',
            'detail_phone': 'Phone',
            'detail_payment_method': 'Payment Method',
            'detail_pay_with_points': 'Pay with points',
            'detail_available_points': 'Available points',
            'detail_total': 'Total',
            'detail_points': 'Points',
            'detail_check_out': 'Check Out',
            'pay_points': 'Pay the points',
            'detail_parameter_wrong': 'Parameter is wrong',
            'detail_failed_data': 'Failed to load order data',
            'detail_creating_order': 'Creating order...',
            'detail_creating_order_fail': 'Order creation failed',
            'detail_status_title': 'Successful exchange of goods',
            'detail_status_check_mailbox': 'Please check your mailbox, we will deliver product within 24 hours.',
            'detail_status_view_order': 'To view the order',
            'detail_status_back_home': 'Back home',
            'detail_points_title': 'Details of points',
            'my_order_points_title': 'My points order'
        },
        'recharge': {
            'title': 'Submit top up application',
            'first_deposit': 'First Deposit bonus',
            'use_binance': 'Use Binance',
            'choose_amount': 'Please choose the amount and continue',
            'current_balance': 'Note:Current balance',
            'confirm_top_up': 'Confirm top up',
            'application_details': 'Top up application details',
            'order_number': 'Order number',
            'application_time': 'Application time',
            'top_up_amount': 'Top up amount',
            'top_up_status': 'Top up status',
            'reviewing': 'Reviewing',
            'application_success': 'Application success',
            'application_failed': 'Application failed',
            'msg_bind_binance': 'Please bind Binance Pay',
            'msg_minimum_bank': 'Minimum 100 to top-up',
            'msg_minimum_binance': 'Minimum 1 to top-up',
            'msg_enter_top_up_amount': 'Please enter top up amount',
            'confirm_title': 'Confirm deposit details',
            'confirm_verify_information': 'Please verify the information',
            'confirm_tip': 'Send money to any of the following accounts using the bound Binance Pay, click on the top right corner to view the tutorial.',
            'confirm_our_pay_id': 'Our Pay ID',
            'confirm_copy': 'Copy',
            'confirm_top_up_amount': 'Top up amount',
            'confirm_confirm_top_up': 'Confirm top up',
            'confirm_msg_copy': 'Copy success',
            'confirm_msg_enter_amount': 'Please enter amount to top up',
            'confirm_transfer_amount': 'Transfer amount minimum of 1',
            'confirm_alert_mes': 'Please confirm that the bound binance pay has been used to pay us.<b style=\'color: red\'> Please wait for 5-10 minutes to arrive. </b>If you have any questions, please contact customer service in time.',
            'confirm_alert_title': 'Submit top up application',
            'confirm_alert_cancel': 'Cancel',
            'confirm_alert_msg_cancelled': 'Cancelled',
            'confirm_alert_confirm': 'Confirm'
        },
        'withdrawal': {
            'title': 'Withdraw',
            'link_now_tip': 'You have not link e-wallet yet, please link and submit withdrawal application again.',
            'link_now': 'Link now',
            'withdrawal_account': 'Withdrawal Account',
            'phone': 'Phone',
            'binance_id': 'Binance ID',
            'nickname': 'Nickname',
            'pay_id': 'Pay ID',
            'withdraw_amount': 'Withdraw Amount',
            'balance': 'balance',
            'processing_fee': 'Processing fee',
            'actual_amount': 'actual amount',
            'msg_withdrawal_account': 'Please select withdrawal account',
            'msg_fill_data': 'Please fill in the data',
            'msg_phone': 'Please enter phone number',
            'msg_binance_id': 'Please enter Binance ID',
            'msg_binance_pay_id': 'Please enter Binance Pay ID',
            'msg_pay_id_err': 'Pay ID format error',
            'msg_withdraw_amount': 'Please enter withdraw amount',
            'msg_insufficient_balance': 'Insufficient balance',
            'msg_mini_withdraw': 'Minimum 160 to withdraw',
            'msg_minimum': 'Minimum',
            'msg_to_withdraw': 'to withdraw',
            'audit_tip': 'Withdrawal has been submitted, waiting for review',
            'audit_sure': 'sure'
        },
        'user_vip': {
            'title': 'Member center',
            'able_purchase': 'Able to purchase item at',
            'off': 'off',
            'level_task1': 'Complete the Deposit of 1USDT and purchase goods 50 times to become a VIP!',
            'level_task2': 'Withdrawals fee',
            'level_task3': 'Withdrawal time',
            'level_task4': 'H',
            'vip_level_unlocked': 'VIP level unlocked',
            'higher_level_unlocked': 'Higher level unlocked',
            'vip_upgrade_requirements': 'VIP upgrade requirements',
            'required_tasks': 'Required tasks',
            'select_one_below': 'Please select one of below',
            'achieved': 'achieved',
            'conditions_met': 'conditions not met',
            'accumulated_participation': 'accumulated participation in game',
            'achieved_top_up': 'Accumulated 50₫ top up',
            'exclusive_coupons': 'exclusive coupons',
            'more_games': 'more games',
            'need_recharge': 'Need to recharge 50₫'
        },
        'promoter': {
            'title': 'Promoter management',
            'apply_agency': 'Apply for agency and become one of us',
            'become_agent': 'Become an agent',
            'repeatedly_delayed': 'Upload may be delayed, please wait a while and do not click repeatedly！',
            'current_commission': 'Current commission',
            'record': 'record',
            'profit_yesterday': 'Profit yesterday',
            'accumulated_withdrawal': 'Accumulated withdrawal',
            'withdraw': 'withdraw',
            'refer_friends': 'Refer Friends',
            'total_agent': 'Total agent',
            'copy_success': 'Copy success',
            'copy_error': 'Copy error',
            'promoter_achievements': 'Promoter achievements',
            'promoter_orders': 'Promoter orders',
            'promoter_ranking': 'Promoter ranking',
            'commission_ranking': 'Commission ranking',
            'list_title': 'Number of agents',
            'list_number_agents': 'Number of agents',
            'list_people': 'people',
            'list_date_joined': 'Date joined',
            'list_item': 'item',
            'order_title': 'Accumulated orders',
            'order_accumulated_orders': 'Accumulated orders',
            'order_commission': 'commission',
            'order_time': 'Order time',
            'order_mark': 'mark',
            'commission_title': 'Promoter achievements',
            'commission_accumulated_commission': 'Accumulated commission',
            'commission_available': 'Commission available for withdrawal',
            'commission_week': 'New members this week',
            'commission_month': 'New members this month',
            'commission_achievement': 'Achievement',
            'commission_rank_title': 'Commission ranking',
            'commission_rank_current': 'Your current ranking',
            'commission_rank_yet': 'You are not in ranking yet',
            'rank_title': 'Promoter ranking',
            'cash_record_title': 'Commission withdrawal details',
            'cash_record_cash_out': 'Cash-out record',
            'user_cash_title': 'Commission withdrawal',
            'user_cash_not_link': 'You have not link e-wallet yet, please link and submit withdrawal application again.',
            'user_cash_link_now': 'Link now',
            'user_cash_service_provider': 'Service provider',
            'user_cash_select_account': 'Please select withdrawal account',
            'user_cash_binance_pay': 'Binance Pay',
            'user_cash_bank_account': 'Bank Account',
            'user_cash_bank_account_pla': 'Please fill in your banks account number',
            'user_cash_ifsc_pla': 'Please fill in your IFSC account number',
            'user_cash_upi_pla': 'Please fill in your UPI account number',
            'user_cash_withdraw': 'Withdraw',
            'user_cash_minimum': 'Minimum',
            'user_cash_to_withdraw': 'to withdraw',
            'user_cash_current_commission': 'Current commission available for withdrawal',
            'user_cash_account': 'Account',
            'user_cash_account_pla': 'Please fill in your alipay user name',
            'user_cash_current_withdrawal': 'Current withdrawal commission',
            'user_cash_to_e_wallet': 'Withdraw to E-wallet',
            'user_cash_to_balance': 'Withdraw to balance',
            'user_cash_insufficient_balance': 'Insufficient balance',
            'user_cash_data_format': 'data in wrong format'
        },
        'service': {
            'title': 'Message records',
            'write_email': 'Please write to us Email'
        }
    }
};